<ms-market-help *ngIf="showMarketHelp" [optionGroup]="optionGroup" [eventHelpText]="eventHelpText"></ms-market-help>
<div class="option-group-container six-pack-container" [ngClass]="tupleClass">
    <div class="option-group-header">
        <span class="six-pack-col" *ngFor="let header of optionHeaders | keyvalue: keepOrder">{{ header.value }}</span>
    </div>
    <ng-container *ngFor="let optionRow of optionRows; trackBy: trackByPlayer">
        <ng-container *ngFor="let column of optionRow.columns | keyvalue: keepOrder; trackBy: trackByCol">
            <div class="option" *ngIf="!column.value">
                <span class="empty-option">-</span>
            </div>
            <ms-bet-builder-option
                *ngIf="column.value"
                [tracking]="{ source: tracking }"
                [option]="column.value"
                [optionGroup]="optionGroup"
                [event]="event"
                [sourceOfPick]="sourceOfPick"></ms-bet-builder-option>
        </ng-container>
    </ng-container>
</div>
